import { cn } from "@/lib/utils";

const CATEGORY_STYLES = {
  General:
    "bg-purple-100 text-purple-700 border-purple-200 dark:bg-purple-900/30 dark:text-purple-300 dark:border-purple-800",
  Environmental:
    "bg-green-100 text-green-800 border-green-200 dark:bg-green-900/30 dark:text-green-300 dark:border-green-800",
  Social:
    "bg-blue-100 text-blue-800 border-slate-200 dark:bg-blue-900/30 dark:text-blue-300 dark:border-blue-800",
  Governance:
    "bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-800",
};

const CategoryBadge = ({ category, className }) => {
  const categoryStyle = CATEGORY_STYLES[category];
  if (!categoryStyle)
    return <span className="text-xs text-muted-foreground">—</span>;
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-xl border px-2 py-0.5 text-xs font-medium shrink-0",
        categoryStyle,
        className,
      )}
    >
      {category}
    </span>
  );
};

export default CategoryBadge;
